import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Button, Box, Typography } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faRepeatAlt } from '@fortawesome/pro-solid-svg-icons'

import { ConfirmationDialog } from '@scoir/modals'

import { CopyToClipboard } from './CopyToClipboard'

import api from 'common/api'

const generateState = () => {
  return {
    promptForGenerate: false,
    promptForRemoval: false,
  }
}

class GenerateSftpKey extends React.Component {
  constructor(props) {
    super(props)
    this.state = generateState()
  }

  openModal(modalFlagName) {
    this.setState({
      [modalFlagName]: true,
    })
  }

  handleKeyGeneration() {
    api.post(`/api/colleges/${this.props.scid}/integrations/sftp/keypair`).then((integrations) => {
      this.setState({ promptForGenerate: false })
      return this.props.onKeyUpdate(integrations.SFTP.Credentials.PublicKey)
    })
  }

  handleKeyRemoval() {
    api.delete(`/api/colleges/${this.props.scid}/integrations/sftp/keypair`).then(() => {
      this.setState({ promptForRemoval: false })
      return this.props.onKeyUpdate('')
    })
  }

  render() {
    return (
      <Box>
        {this.props.publicKey === '' && (
          <Box mt={2}>
            <Button
              color="primary"
              variant="contained"
              disabled={this.props.disabled}
              onClick={() => this.openModal('promptForGenerate')}
            >
              Generate A Fresh Key
            </Button>
          </Box>
        )}
        {this.props.publicKey !== '' && (
          <Fragment>
            <Box>
              <CopyToClipboard
                label="Public Key"
                value={this.props.publicKey}
              />
            </Box>
            <Box
              mt={2}
              display="flex"
              gridGap={8}
            >
              <Button
                color="primary"
                variant="outlined"
                disabled={this.props.disabled}
                onClick={() => this.openModal('promptForGenerate')}
                startIcon={<FontAwesomeIcon icon={faRepeatAlt} />}
              >
                Regenerate
              </Button>
              <Button
                color="primary"
                variant="outlined"
                disabled={this.props.disabled}
                onClick={() => this.openModal('promptForRemoval')}
                startIcon={<FontAwesomeIcon icon={faTimes} />}
              >
                Remove
              </Button>
            </Box>
          </Fragment>
        )}

        <ConfirmationDialog
          open={this.state.promptForGenerate}
          headerText="Generate a New SFTP Key"
          onClose={() => this.setState({ promptForGenerate: false })}
          onConfirm={() => this.handleKeyGeneration()}
        >
          <Typography>
            Generating a new key SFTP key will update the SFTP integration status to &quot;Inactive&quot;. Would you
            like to proceed?
          </Typography>
        </ConfirmationDialog>
        <ConfirmationDialog
          open={this.state.promptForRemoval}
          headerText="Remove your SFTP Key"
          onClose={() => this.setState({ promptForRemoval: false })}
          onConfirm={() => this.handleKeyRemoval()}
        >
          <Typography>
            Removing your SFTP key will update the SFTP integration status to &quot;Inactive&quot;. Would you like to
            proceed?
          </Typography>
        </ConfirmationDialog>
      </Box>
    )
  }
}

GenerateSftpKey.propTypes = {
  scid: PropTypes.number.isRequired,
  publicKey: PropTypes.string,
  disabled: PropTypes.bool,
  onKeyUpdate: PropTypes.func.isRequired,
}

export default GenerateSftpKey
